import React, { useState } from "react";
import logo from "../assets/logo.svg";
import { NavLink } from "react-router-dom";

function Header() {
  const [isActive, setActive] = useState(false);

  const toggleCollapse = () => {
    setActive(!isActive);
  };

  return (
    <>
      <div className="header">
        <div className="header-inner">
          <div className="logo">
            <a className="navbar-brand" href="/">
              <img
                alt="brand"
                src={logo}
                width="140"
                height="20"
                decoding="async"
                data-nimg="1"
                loading="lazy"
                style={{ color: "transparent" }}
              />
            </a>
          </div>
          <div className="my_trigger">
            <div
              className={
                isActive
                  ? "hamburger hamburger--collapse-r is-active"
                  : "hamburger"
              }
              onClick={toggleCollapse}>
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={isActive ? "leftpart active" : "leftpart"}>
        <div className="leftpart_inner">
          <div className="logo">
            <a className="navbar-brand" href="/">
              <img src={logo} alt="" srcset="" />
            </a>
          </div>
          <div className="menu">
            <ul>
              <li>
                <NavLink className="navbar__link" to="/">
                  <img
                    alt="homerun"
                    src="https://tokyo-nextjs.vercel.app/img/svg/home-run.svg"
                    width="15"
                    height="15"
                    decoding="async"
                    data-nimg="1"
                    className="svg"
                    loading="lazy"
                    style={{ color: "transparent" }}
                  />
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink className="navbar__link" to="/about">
                  <img
                    alt="homerun"
                    src="https://tokyo-nextjs.vercel.app/img/svg/avatar.svg"
                    width="15"
                    height="15"
                    decoding="async"
                    data-nimg="1"
                    className="svg"
                    loading="lazy"
                    style={{ color: "transparent" }}
                  />
                  About
                </NavLink>
              </li>
              <li>
                <NavLink className="navbar__link" to="/service">
                  <img
                    alt="homerun"
                    src="https://tokyo-nextjs.vercel.app/img/svg/setting.svg"
                    width="15"
                    height="15"
                    decoding="async"
                    data-nimg="1"
                    className="svg"
                    loading="lazy"
                    style={{ color: "transparent" }}
                  />
                  Service
                </NavLink>
              </li>
              <li>
                <NavLink className="navbar__link" to="/portfolio">
                  <img
                    alt="homerun"
                    src="https://tokyo-nextjs.vercel.app/img/svg/briefcase.svg"
                    width="15"
                    height="15"
                    decoding="async"
                    data-nimg="1"
                    className="svg"
                    loading="lazy"
                    style={{ color: "transparent" }}
                  />
                  Portfolio
                </NavLink>
              </li>
              <li>
                <NavLink className="navbar__link" to="/contact">
                  <img
                    alt="homerun"
                    src="https://tokyo-nextjs.vercel.app/img/svg/mail.svg"
                    width="15"
                    height="15"
                    decoding="async"
                    data-nimg="1"
                    className="svg"
                    loading="lazy"
                    style={{ color: "transparent" }}
                  />
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="copyright">
            <p>© 2023 Tangerang</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
